import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWheelchairNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M7.52 12.39a4.085 4.085 0 104.09 4.09 4.093 4.093 0 00-4.09-4.09zm0 6.52a2.436 2.436 0 11.01-4.871 2.436 2.436 0 01-.01 4.871z"
        fill=""
      />
      <path
        d="M27.5 15.17a4.332 4.332 0 00-3.48 1.77l-3.72-1.95a.9.9 0 01-.479-.8V12h-1.65v2.193a2.532 2.532 0 00.97 1.977h-4.33a7.332 7.332 0 10-1.41 4.658h9.986A4.326 4.326 0 1027.5 15.17zm-20 7a5.67 5.67 0 110-11.339 5.67 5.67 0 010 11.339zm15.69-3h-8.87a6.94 6.94 0 00.38-1.34h7.47l1.14.61a2.95 2.95 0 00-.12.732v-.002zm4.31 3a2.668 2.668 0 01-2.67-2.67 2.006 2.006 0 01.01-.25l2.33 1.23v-1.87l-1.66-.88a2.629 2.629 0 011.99-.9 2.67 2.67 0 010 5.34z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWheelchairNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsWheelchairNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWheelchairNormalMedium;
